import React from "react";
import LegalLayout, { LEGAL_ENTITY } from "../../components/LegalLayout";

export default function PrivacyPage() {
  const sections = [
    {
      heading: "Introducere",
      body: [
        "VIS DE ZI respectă confidențialitatea datelor dumneavoastră personale și se angajează să le protejeze în conformitate cu Regulamentul (UE) 2016/679 privind protecția datelor (GDPR) și legislația națională aplicabilă.",
        "Această Politică de confidențialitate descrie ce date colectăm, de ce le colectăm și cum le folosim.",
      ],
    },
    {
      heading: "Operatorul de date",
      body: [
        "Operatorul datelor dumneavoastră personale este Alina Stancu PFA, având brandul comercial VIS DE ZI.",
        "Pentru orice întrebări legate de datele personale, ne puteți contacta la: office@visdezi.ro",
      ],
    },
    {
      heading: "Ce date colectăm",
      body: [
        "Pentru procesarea comenzilor colectăm: nume și prenume, adresă de email, număr de telefon, adresă de livrare (stradă, oraș, județ, cod poștal).",
        "Pentru newsletter colectăm doar adresa de email.",
        "Pentru formularul de contact colectăm: nume, email, subiect și mesaj.",
        "Nu colectăm, nu stocăm și nu prelucrăm datele cardului dumneavoastră bancar. Plata se face ramburs la curier.",
      ],
    },
    {
      heading: "De ce colectăm aceste date (scopul prelucrării)",
      body: [
        "Pentru a procesa și livra comenzile dumneavoastră.",
        "Pentru a vă contacta în legătură cu comanda (confirmare, expediere, întrebări).",
        "Pentru a vă trimite newsletter-ul VIS DE ZI, dacă v-ați abonat (puteți renunța oricând).",
        "Pentru a răspunde întrebărilor dumneavoastră transmise prin formularul de contact.",
        "Pentru respectarea obligațiilor legale (contabile, fiscale).",
      ],
    },
    {
      heading: "Temeiul juridic",
      body: [
        "Executarea contractului de vânzare (art. 6 alin. 1 lit. b GDPR) — pentru procesarea comenzilor.",
        "Consimțământul dumneavoastră (art. 6 alin. 1 lit. a GDPR) — pentru newsletter.",
        "Obligația legală (art. 6 alin. 1 lit. c GDPR) — pentru păstrarea documentelor fiscale.",
        "Interesul legitim (art. 6 alin. 1 lit. f GDPR) — pentru a răspunde solicitărilor dumneavoastră.",
      ],
    },
    {
      heading: "Cât timp păstrăm datele",
      body: [
        "Datele legate de comenzi sunt păstrate pentru perioada obligatorie legală (10 ani pentru documente fiscale).",
        "Adresa de email pentru newsletter este păstrată până când solicitați dezabonarea.",
        "Mesajele din formularul de contact sunt păstrate maximum 2 ani după rezolvarea solicitării.",
      ],
    },
    {
      heading: "Cui transmitem datele",
      body: [
        "Curierilor (Fan Courier, Sameday) — doar datele necesare livrării.",
        "Serviciilor de email (Resend) — doar adresa de email pentru emailuri tranzacționale.",
        "Autorităților publice, dacă legea ne obligă.",
        "Nu vindem, nu închiriem și nu transferăm datele dumneavoastră către terți în scopuri comerciale.",
      ],
    },
    {
      heading: "Drepturile dumneavoastră",
      body: [
        "Dreptul de acces — să știți ce date avem despre dumneavoastră.",
        "Dreptul la rectificare — să corectăm datele inexacte.",
        "Dreptul la ștergere („dreptul de a fi uitat”).",
        "Dreptul la restricționarea prelucrării.",
        "Dreptul la portabilitate — să primiți datele într-un format structurat.",
        "Dreptul la opoziție — să vă opuneți prelucrării în anumite condiții.",
        "Dreptul de a vă retrage consimțământul oricând (ex: dezabonare newsletter).",
        "Dreptul de a depune o plângere la Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP) — www.dataprotection.ro",
      ],
    },
    {
      heading: "Cum vă exercitați drepturile",
      body: [
        "Pentru oricare dintre drepturile de mai sus, trimiteți un email la office@visdezi.ro cu subiectul „GDPR — [tipul cererii]”.",
        "Vom răspunde solicitării dumneavoastră în maximum 30 de zile.",
      ],
    },
    {
      heading: "Securitatea datelor",
      body: [
        "Luăm măsuri tehnice și organizatorice rezonabile pentru a proteja datele dumneavoastră de acces neautorizat, pierdere, utilizare greșită sau dezvăluire.",
        "Datele sunt stocate pe servere securizate, iar transmisia prin Site este criptată (HTTPS).",
      ],
    },
    {
      heading: "Modificări",
      body: [
        "Această politică poate fi actualizată. Vom afișa data ultimei actualizări în partea de sus a paginii.",
      ],
    },
  ];

  return (
    <LegalLayout
      eyebrow="Document legal · GDPR"
      title="Politica de confidențialitate"
      lastUpdated="1 octombrie 2026"
      sections={sections}
      legalEntity={LEGAL_ENTITY}
    />
  );
}
